<template>
  <div class="page-403">
    <div class="page-content">
    403,权限不足
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-403'
}
</script>

<style scoped>
.page-403 .page-content
{
  width:100%;
  height:80px;
  line-height: 80px;
  color:#bbb;
  text-align: center;
  font-size: 18px;
}
</style>
